import useAppQuery from 'core/query-client/useAppQuery';
import { getProjectOutputs } from 'shared/api/projects/http';

export const createUseProjectOutputsQueryKey = (projectId) => ['project-outputs', Number(projectId)];

const useProjectOutputsQuery = (projectId) =>
  useAppQuery(createUseProjectOutputsQueryKey(projectId), () => getProjectOutputs(projectId));

export default useProjectOutputsQuery;
